import React from "react";

import Typography from "@mui/material/Typography";

import { styles } from "./styles";

interface DetailRowProps {
  label: string;
  value: string;
  maxLines?: number;
}

const DetailRow: React.FC<DetailRowProps> = ({
  label,
  value,
  maxLines = 1,
}) => (
  <>
    <Typography color="grey700">{label}</Typography>
    <Typography
      sx={maxLines > 1 ? styles.lineClamp(maxLines) : undefined}
      noWrap={maxLines === 1}
    >
      {value}
    </Typography>
  </>
);

export default DetailRow;
